export default __webpack_public_path__ + "assets/button_google.b3136124.png";